import React, { useCallback } from "react";
import { useFetch } from "../../../../utils/hooks";
import "./ContainerPane.scss";
import { Spin, Table } from "antd";
import { ReactSVG } from "react-svg";
import { getPanesIcon } from "../../../../utils/images";
import { getShipmentDetailsContainer } from "../../../../services/shipments";

const ContainerPane = ({ shipment }) => {
  const { data, loading } = useFetch(useCallback(() => getShipmentDetailsContainer(shipment.id), [shipment.id]))

  const containers = data?.containers || [];

  if (loading) {
    return <Spin size="large" className="spinner" />
  }

  const columns = [
    {
      title: 'Container Number',
      dataIndex: 'number',
      key: 'number',
    },
    {
      title: 'Container Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Destination Gate Out',
      dataIndex: 'gate_out',
      key: 'gate_out',
    },
    {
      title: 'Empty Return',
      dataIndex: 'empty_return',
      key: 'empty_return',
    }
  ]

  return (
    <div className="ContainerPane pane">
      <div className="pane__header">
        <ReactSVG src={getPanesIcon('containers')} />
        <div className="pane__title">Containers</div>
      </div>
      <div className="pane__wrapper">
        {containers.length
          ?
          <div className="elements">
            <div className="elements-table">
              <Table
                rowClassName={"ant-table-row"}
                dataSource={containers}
                columns={columns}
              />
            </div>
          </div>
          :
          <div className="no-elements">
            <span>It seems you don't have any containers yet. </span>
          </div>
        }
      </div>
    </div>
  )
}

export default ContainerPane;
